/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components/macro";
import {  NavLink, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import * as Yup from "yup";
import { connect } from "react-redux";
import _ from "lodash";
import {
  CardContent,
  Grid,
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,

  Paper as MuiPaper,
  TextField,
  Typography,
  FormControl,

  Button,
  Snackbar,
  Alert,
  Autocomplete,
} from "@mui/material";
import { spacing } from "@mui/system";
import axios from "../../CustomAxios";
import { Formik } from "formik";
import Loading from "../components/Loading";
import swal from "sweetalert";

const Card = styled(MuiCard)(spacing);



const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Paper = styled(MuiPaper)(spacing);

const getBrandTechnology = async (setTechnology, setBrand, setLoader) => {
  try {
    const userData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + userData.access_token,
      },
    };
    const technologyData = await axios.get(
      `/api/v1/${userData.type}/plate_inventory/technology`,
      config
    );
    const brandData = await axios.get(
      `/api/v1/${userData.type}/plate_inventory/brand`,
      config
    );
    if (technologyData.data.success) {
      setTechnology(technologyData.data.data);
    }
    if (brandData.data.success) {
      setBrand(brandData.data.data);
    }
    setLoader(false);
  } catch (e) {
    console.log(e);
    setLoader(false);
    console.log(e.response.data.error);
  }
};

function FormDetails({ technologies, brands, missingPermissions }) {
  const navigate = useNavigate();

  const [err, setErr] = useState("");
  const [success, setSuccess] = useState(false);
  const [loader, setLoader] = useState(false);
  const snackRef = useRef(null);
  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, open } = state;
  const handleClick = (newState) => () => {
    setState({ open: true, ...newState });
  };
  const handleClose = () => {
    setState({ ...state, open: false });
  };

  const submit = async (
    height,
    width,
    technology,
    brand,
    hsn,
    company,
    thickness,
    resetForm
  ) => {
    try {
      setLoader(true);
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData.access_token,
        },
      };
      const { data } = await axios.post(
        `/api/v1/${userData.type}/plate_inventory`,
        {
          height,
          width,
          technology: technology._id,
          brand: brand._id,
          hsn,
          company,
          thickness,
        },
        config
      );
      if (data.success) {
        setLoader(false);
        setSuccess(true);
        setErr("");
        snackRef.current.click();
        resetForm({ values: "" });
        navigate("/dashboard/inventory", {
          state: { message: "Plate Created Successfully", success: true },
        });
      }
    } catch (e) {
      setLoader(false);
      setErr(e.response.data.error);
      snackRef.current.click();
    }
  };
  return (
    <>
      <Formik
        initialValues={{
          height: "",
          width: "",
          technology: "",
          brand: "",
          hsn: "",
          company: "",
          thickness: "",
          submit: false,
        }}
        validationSchema={Yup.object().shape({
          brand: Yup.object().required("Brand is required"),
          technology: Yup.object().required("Technology is required"),
          height: Yup.string().required("Height is required"),
          width: Yup.string().required("Width is required"),
          hsn: Yup.string().required("HSN/SAC is required"),
          company: Yup.string().required("Company is required"),
          thickness: Yup.string().required("Thickness is required"),
        })}
        onSubmit={async (
          values,
          { setErrors, setStatus, setSubmitting, resetForm }
        ) => {
          try {
            submit(
              values.height,
              values.width,
              values.technology,
              values.brand,
              values.hsn,
              values.company,
              values.thickness,
              resetForm
            );
          } catch (error) {
            const message = error.message || "Something went wrong";

            setStatus({ success: false });
            setErrors({ submit: message });
            setSubmitting(false);
          }
        }}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          setFieldValue,
          isSubmitting,
          touched,
          values,
        }) => (
          <form noValidate onSubmit={handleSubmit} autoComplete="off">
            <Button
              ref={snackRef}
              style={{ display: "none" }}
              onClick={handleClick({ vertical: "top", horizontal: "center" })}
            >
              Click
            </Button>
            <Snackbar
              anchorOrigin={{ vertical, horizontal }}
              open={open}
              onClose={handleClose}
              key={vertical + horizontal}
            >
              {err ? (
                <Alert mt={2} mb={4} severity="error">
                  {err}
                </Alert>
              ) : success ? (
                <Alert mt={2} mb={4} severity="success">
                  Plate created Successfully
                </Alert>
              ) : null}
            </Snackbar>
            {!loader ? (
              <Card mb={6}>
                <CardContent>
                  <Paper elevation={3} style={{ padding: "2%" }}>
                    <Grid container spacing={5}>
                      <Grid item xs={12} lg={12} md={12}>
                        <Typography variant="h6" gutterBottom>
                          Plate Details
                        </Typography>
                      </Grid>
                      {/* <Grid item xs={12} md={12} lg={12}>
                        <FormControl
                          fullWidth
                          error={Boolean(touched.brand && errors.brand)}
                        >
                          <Select
                            name="brand"
                            id="search-field"
                            value={values.brand}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            displayEmpty
                            inputProps={{ "aria-label": "Without label" }}
                          >
                            <MenuItem value={""} disabled>
                              Select Brand
                            </MenuItem>
                            {brands.map((brand) => {
                              return (
                                <MenuItem value={brand}>{brand.name}</MenuItem>
                              );
                            })}
                          </Select>
                          <FormHelperText>Please Select Brand</FormHelperText>
                        </FormControl>
                      </Grid> */}
                      <Grid item xs={12} md={12} lg={12}>
                        <FormControl
                          fullWidth
                          error={Boolean(touched.brand && errors.brand)}
                        >
                          <Autocomplete
                            id="combo-box-demo"
                            options={brands}
                            value={values?.brand?.name}
                            onChange={(event, newValue) => {
                              
                              setFieldValue("brand", newValue || "");
                            }}
                            onBlur={handleBlur}
                            getOptionLabel={(option) => option?.name}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                error={Boolean(touched.brand && errors.brand)}
                                helperText={touched.brand && errors.brand}
                                label="Select Brand"
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>
                      {/* <Grid item xs={12} md={12} lg={12}>
                        <FormControl
                          error={Boolean(
                            touched.technology && errors.technology
                          )}
                          fullWidth
                        >
                          <Select
                            name="technology"
                            id="search-field"
                            error={Boolean(
                              touched.technology && errors.technology
                            )}
                            onBlur={handleBlur}
                            value={values.technology}
                            onChange={handleChange}
                            displayEmpty
                            inputProps={{ "aria-label": "Without label" }}
                          >
                            <MenuItem value={""} disabled>
                              Select Technology
                            </MenuItem>
                            {technologies.map((technology) => {
                              return (
                                <MenuItem value={technology}>
                                  {technology.name}
                                </MenuItem>
                              );
                            })}
                          </Select>
                          <FormHelperText>
                            Please Select Technology
                          </FormHelperText>
                        </FormControl>
                      </Grid> */}
                      <Grid item xs={12} md={12} lg={12}>
                        <FormControl
                          fullWidth
                          error={Boolean(
                            touched.technology && errors.technology
                          )}
                        >
                          <Autocomplete
                            id="combo-box-demo"
                            options={technologies}
                            value={values?.technology?.name}
                            onChange={(event, newValue) => {
                              setFieldValue("technology", newValue || "");
                            }}
                            onBlur={handleBlur}
                            getOptionLabel={(option) => option?.name}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                error={Boolean(
                                  touched.technology && errors.technology
                                )}
                                helperText={
                                  touched.technology && errors.technology
                                }
                                label="Select Technology"
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={6} lg={3}>
                        <TextField
                          fullWidth
                          name="height"
                          type="number"
                          value={values.height}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={Boolean(touched.height && errors.height)}
                          id="search-field"
                          label="Height"
                          helperText={touched.height && errors.height}
                        />
                      </Grid>
                      <Grid item xs={12} md={6} lg={3}>
                        <TextField
                          name="width"
                          type="number"
                          fullWidth
                          value={values.width}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={Boolean(touched.width && errors.width)}
                          id="search-field"
                          label="Width"
                          helperText={touched.width && errors.width}
                        />
                      </Grid>
                      <Grid item xs={12} md={6} lg={3}>
                        <TextField
                          name="thickness"
                          type="number"
                          fullWidth
                          value={values.thickness}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={Boolean(touched.thickness && errors.thickness)}
                          id="search-field"
                          label="Thickness"
                          helperText={touched.thickness && errors.thickness}
                        />
                      </Grid>
                      <Grid item xs={12} md={6} lg={3}>
                        <TextField
                          name="company"
                          fullWidth
                          value={values.company}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={Boolean(touched.company && errors.company)}
                          id="search-field"
                          label="Company"
                          helperText={touched.company && errors.company}
                        />
                      </Grid>
                      <Grid item xs={12} md={6} lg={3}>
                        <TextField
                          name="hsn"
                          fullWidth
                          value={values.hsn}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={Boolean(touched.hsn && errors.hsn)}
                          id="search-field"
                          label="HSN/SAC"
                          helperText={touched.hsn && errors.hsn}
                        />
                      </Grid>

                      <Grid item xs={12} md={12} lg={12}>
                        <Button
                          type="submit"
                          style={{ textAlign: "center", margin: "10px" }}
                          mr={2}
                          variant="contained"
                          color="primary"
                          disabled={
                            isSubmitting || missingPermissions.length > 0
                          }
                        >
                          Submit
                        </Button>
                        {/* <Button
                        style={{ textAlign: "center", background: "red" }}
                        mr={2}
                        variant="contained"
                        color="primary"
                      >
                        Reset
                      </Button> */}
                      </Grid>
                    </Grid>
                  </Paper>
                </CardContent>
              </Card>
            ) : (
              <Loading />
            )}
          </form>
        )}
      </Formik>
    </>
  );
}

function AddPlate({ auths }) {
  const [loader, setLoader] = useState(false);
  const [technology, setTechnology] = useState([]);
  const [brand, setBrand] = useState([]);

  const [missingPermissions, setMissingPermissions] = useState([]);
  let requiredPermissions = [
    "view_technology_list",
    "view_brand_list",
    "create_plate",
  ];

  useEffect(() => {
    if (auths?.user) {
      let userPermissions = auths.user?.role?.permissions;
      if (userPermissions) {
        const missing = _.difference(requiredPermissions, userPermissions);
        setMissingPermissions(missing);
        if (missing.length > 0) {
          swal(
            "",
            `You are unauthorized to complete this action because you do not have the following permissions

            ${_.toUpper(missing.join(", ").replace(/_/g, " "))}
            `,
            "error"
          );
        }
      }
    }
  }, [auths.user]);

  useEffect(() => {
    getBrandTechnology(setTechnology, setBrand, setLoader);
  }, []);

  if (!loader) {
    return (
      <React.Fragment>
        <Helmet title="Alpha Plus" />
        <Grid
          justifyContent="space-between"
          alignItems="center"
          container
          spacing={10}
          mb={4}
        >
          <Grid item>
            <Typography
              variant="h4"
              gutterBottom
              display="inline"
              sx={{ fontWeight: 600 }}
              color="primary"
            >
              ADD PLATE
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label="Breadcrumb" mt={2}>
              <Link component={NavLink} to="/dashboard/tasks">
                Dashboard
              </Link>
              <Link component={NavLink} to="/dashboard/inventory">
                Inventory
              </Link>
              <Typography>Add Plate</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <Grid container spacing={6}>
          <Grid item xs={12}>
            <FormDetails
              missingPermissions={missingPermissions}
              brands={brand}
              technologies={technology}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  } else {
    return <Loading />;
  }
}

const mapStateToProps = (state) => ({
  auths: state.auths,
});
export default connect(mapStateToProps, null)(AddPlate);
